let activeChallenge = null

const getAuthPayload = (response) => {
  if (response?.mfa_required) {
    return response
  }

  if (response?.data?.mfa_required) {
    return response.data
  }

  if (response?.data?.data?.mfa_required) {
    return response.data.data
  }

  return null
}

const beginMfaChallenge = (response, options = {}) => {
  const payload = getAuthPayload(response)
  if (!payload?.mfa_token) {
    return false
  }

  activeChallenge = {
    token: payload.mfa_token,
    methods: Array.isArray(payload.methods) ? payload.methods : [],
    successPath: options.successPath || '/dashboard',
  }

  return true
}

const getMfaChallenge = () => activeChallenge

const clearMfaChallenge = () => {
  activeChallenge = null
}

export {
  beginMfaChallenge,
  clearMfaChallenge,
  getAuthPayload,
  getMfaChallenge,
}
